import React from 'react';
import { string, bool, func, number } from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';

import { PromoSelectCta } from '../../../promo-select-cta/PromoSelectCta';
import { PromoQuantity } from '../../../promo-quantity/PromoQuantity';
import { PromoAddToCart } from '../../../promo-add-to-cart/PromoAddToCart';
import { PromoWarningMessage } from '../PromoWarningMessage';
import { PromoCheckboxCta } from '../../../promo-checkbox-cta/PromoCheckboxCta';

import './CallToActionSection.scss';

export const CallToActionSection = React.memo((props) => {

  const {
    isBogo,
    isMsb,
    isBmsm,
    quantityWarningText,
    onSelect,
    selected,
    inCartQuantity,
    itemId,
    setQuantityWarningText,
    showQuantityWarningState,
    singleItemIdToDisplay,
    displayPosition
  } = props;

  return (
    <div className="promo-pod-call-to-action" style={{ display: 'flex' }}>
      <Col fallback={3} nopadding>
        {(isBogo && singleItemIdToDisplay) && <p className="promo-pod-call-to-action__free-message u__bold">FREE</p>}
        {(!isBogo && quantityWarningText) && <PromoWarningMessage message={quantityWarningText} />}
      </Col>
      <Col fallback={8} nopadding className="promo-pod-call-to-action__actions">
        {(isBogo && !singleItemIdToDisplay && (
          <PromoSelectCta
            onSelect={onSelect}
            selected={selected}
            dark={!selected}
          />
        ))}

        {/* Render checkbox ATC for BOGO single item */ }
        {(isBogo && singleItemIdToDisplay) && (
          <PromoCheckboxCta
            onSelect={onSelect}
            selected={selected}
            itemId={itemId}
          />
        )}

        {/* Render quantity box if there is at least one of this item in cart */}
        {((isMsb || isBmsm) && !!inCartQuantity) && (
          <PromoQuantity
            itemId={itemId}
            setWarningText={setQuantityWarningText}
            showWarningState={showQuantityWarningState}
          />
        )}

        {/* Render ATC button if no items in cart */}
        {((isMsb || isBmsm) && !inCartQuantity) && (
          <PromoAddToCart itemId={itemId} displayPosition={displayPosition} />
        )}
      </Col>
    </div>
  );
});

CallToActionSection.displayName = 'PromoPodCallToActionSection';

CallToActionSection.propTypes = {
  isBogo: bool.isRequired,
  isMsb: bool.isRequired,
  isBmsm: bool.isRequired,
  quantityWarningText: string.isRequired,
  onSelect: func.isRequired,
  selected: bool.isRequired,
  inCartQuantity: number.isRequired,
  itemId: string.isRequired,
  setQuantityWarningText: func.isRequired,
  showQuantityWarningState: bool.isRequired,
  singleItemIdToDisplay: string,
  displayPosition: string.isRequired
};

CallToActionSection.defaultProps = {
  singleItemIdToDisplay: ''
};
